import template from './referralAlert.html';

export default {
  template,
};
